export default "__VITE_ASSET__393fd372__"